import { createAction, props } from '@ngrx/store';

export const updatePlatform = createAction('[Platform] update platform', props<{platform: any}>());
export const updateWebsite = createAction('[Platform] update website', props<{website: any}>());
export const updateWebsiteInvalid = createAction('[Platform] update website invalid', props<{website_invalid: any}>());
export const updateMaxMonthlyOrders = createAction('[Platform] update max monthly orders', props<{maxMonthlyOrders: any}>());
export const updatePhone = createAction('[Platform] update phone', props<{phone: any}>());
export const updateSaving = createAction('[Platform] update saving', props<{saving: any}>());
export const updatePopover = createAction('[Platform] update popover', props<{popover: any}>());
export const updateAll = createAction('[Platform] update all', props<{payload: any}>());
export const saveData = createAction('[Platform] save data');
